import * as React from 'react';

import { ReactFCC, Tooltip } from '@notino/react-styleguide';

import { TooltipContent } from '@components/Tooltip/Content';

import { IConditionalFreeDelivery } from '../model';

import { Link } from './styled';

interface IConditionsTooltipProps {
  targets: IConditionalFreeDelivery['targets'];
}
export const ConditionsTooltip: ReactFCC<IConditionsTooltipProps> = ({
  children,
  targets,
}) => {
  const content = targets.map((target, idx) => (
    <React.Fragment key={target.url}>
      <Link href={target.url}>{target.name}</Link>
      {idx < targets.length - 1 && ', '}
    </React.Fragment>
  ));
  return (
    <Tooltip
      interactive={true}
      content={<TooltipContent>{content}</TooltipContent>}
      wrapText={true}
      alignDesktop={true}
    >
      <u>{children}</u>
    </Tooltip>
  );
};
